import { Pipe, PipeTransform } from '@angular/core'
import { EstimateBalance } from '@mmx/shared'

import { balanceOutstanding } from '../balance-utils'

@Pipe({
  name: 'balanceOutstanding',
  standalone: true,
})
export class BalanceOutstandingPipe implements PipeTransform {
  transform(value: EstimateBalance | null | undefined): number {
    if (value == null) {
      return 0
    }
    return balanceOutstanding(value)
  }
}
